import { sortArray } from '@nu-art/ts-common';
import { filterPathwaysByContextRule } from '@app/org-shared';
export const getMatchingPathwaysByContextRules = (pathways, contextRules) => {
    const result = {};
    for (const contextRule of contextRules) {
        const matchingPathways = filterPathwaysByContextRule(pathways, [contextRule]);
        result[contextRule._id] = sortArray(matchingPathways, pathway => pathway.label.toLowerCase());
    }
    return result;
};
//# sourceMappingURL=utils.js.map